import { render, staticRenderFns } from "./_tournamentMatch.vue?vue&type=template&id=2d430e9f&lang=pug&"
import script from "./_tournamentMatch.vue?vue&type=script&lang=js&"
export * from "./_tournamentMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports